"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DependencyPostOperations", {
    enumerable: true,
    get: function() {
        return DependencyPostOperations;
    }
});
const _common = require("@nestjs/common");
const _dependencyservice = require("~/services/dependency.service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let DependencyPostOperations = class DependencyPostOperations {
    async handle(context, { payload, operation }) {
        switch(operation){
            case 'checkDependency':
                return await this.dependencyService.checkDependency(context, {
                    entityType: payload.entityType,
                    entityId: payload.entityId
                });
        }
    }
    constructor(dependencyService){
        this.dependencyService = dependencyService;
        this.operations = [
            'checkDependency'
        ];
        this.httpMethod = 'POST';
    }
};
DependencyPostOperations = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _dependencyservice.DependencyService === "undefined" ? Object : _dependencyservice.DependencyService
    ])
], DependencyPostOperations);
